export default {
    name: 'Name',
    statisticSurvey: 'Statistikerhebung',
    type: 'Typ',
    identifier: 'Kürzel',
    is_active: 'Aktiv',
    sort: 'Sortierung',
}